export default __webpack_public_path__ + "static/light-node@2x-fd8b50da207a66001c03ee8802426027.png";